import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { setShowSelectedOnly } from 'store/CustomReports/actions'

function FilterSelectedOnly({ item, items }) {
  const dispatch = useDispatch()
  const { showSelectedOnly } = useSelector((store) => store.customReports)

  return (
    <>
      {items?.length || !!item || showSelectedOnly ? (
        <button
          onClick={() => {
            if (!showSelectedOnly) {
              dispatch(setShowSelectedOnly(true))
            } else {
              dispatch(setShowSelectedOnly(false))
            }
          }}
          className='btn btn-info mb-4'
        >
          {!showSelectedOnly ? 'Filter selected only' : 'Show all'}
        </button>
      ) : null}
    </>
  )
}

export default FilterSelectedOnly
